import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import Promocard from './feedCards/promocard';

const PromocardCarousel = ({ cards }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  return (
    <Box>
      <Box className={classes.carouselMain}>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {cards &&
            cards.map((card, index) => (
              <div className={classes.imgContainer} key={card.id}>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Promocard post={card} />
                ) : null}
              </div>
            ))}
        </SwipeableViews>
      </Box>
      <Box>
        <Box className={classes.carouselMain} py={2}>
          {cards &&
            cards.map((card, index) => (
              <li
                key={card.id}
                className={` ${classes.carouselPosition} ${
                  activeStep === index && classes.red
                }`}
              ></li>
            ))}
        </Box>
      </Box>
      <Box mb={2} />
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  carouselMain: {
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  imgContainer: {
    height: '100%',
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  carouselPosition: {
    background: theme.palette.grey['100'],
    listStyle: 'none',
    width: '8px',
    height: '8px',
    marginRight: theme.spacing(1),
    borderRadius: '50%',
  },
  red: {
    background: theme.palette.primary.main,
  },
}));
export default PromocardCarousel;
